{
  "newFeature": "A streamlined application switcher now includes only apps enabled for you in a single list.",
  "newLayout": "New layout",
  "ok": "Ok"
} 
